var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 222,
    viewBox: "0 0 285 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 78,
    r: 3,
    transform: "rotate(-180 111 78)",
    fill: "#14B6A7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 78,
    r: 3,
    transform: "rotate(-180 96 78)",
    fill: "#14B6A7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 78,
    r: 3,
    transform: "rotate(-180 81 78)",
    fill: "#14B6A7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 78,
    r: 3,
    transform: "rotate(-180 66 78)",
    fill: "#14B6A7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 78,
    r: 3,
    transform: "rotate(-180 51 78)",
    fill: "#14B6A7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 78,
    r: 3,
    transform: "rotate(-180 36 78)",
    fill: "#14B6A7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 63,
    r: 3,
    transform: "rotate(-180 111 63)",
    fill: "#14B6A7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 63,
    r: 3,
    transform: "rotate(-180 96 63)",
    fill: "#14B6A7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 63,
    r: 3,
    transform: "rotate(-180 81 63)",
    fill: "#14B6A7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 63,
    r: 3,
    transform: "rotate(-180 66 63)",
    fill: "#14B6A7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 63,
    r: 3,
    transform: "rotate(-180 51 63)",
    fill: "#14B6A7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 63,
    r: 3,
    transform: "rotate(-180 36 63)",
    fill: "#14B6A7"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 48,
    r: 3,
    transform: "rotate(-180 111 48)",
    fill: "#14B6A7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 48,
    r: 3,
    transform: "rotate(-180 96 48)",
    fill: "#14B6A7"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 48,
    r: 3,
    transform: "rotate(-180 81 48)",
    fill: "#14B6A7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 48,
    r: 3,
    transform: "rotate(-180 66 48)",
    fill: "#14B6A7"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 48,
    r: 3,
    transform: "rotate(-180 51 48)",
    fill: "#14B6A7"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 48,
    r: 3,
    transform: "rotate(-180 36 48)",
    fill: "#14B6A7"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 33,
    r: 3,
    transform: "rotate(-180 111 33)",
    fill: "#14B6A7"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 33,
    r: 3,
    transform: "rotate(-180 96 33)",
    fill: "#14B6A7"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 33,
    r: 3,
    transform: "rotate(-180 81 33)",
    fill: "#14B6A7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 33,
    r: 3,
    transform: "rotate(-180 66 33)",
    fill: "#14B6A7"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 33,
    r: 3,
    transform: "rotate(-180 51 33)",
    fill: "#14B6A7"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 33,
    r: 3,
    transform: "rotate(-180 36 33)",
    fill: "#14B6A7"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 18,
    r: 3,
    transform: "rotate(-180 111 18)",
    fill: "#14B6A7"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 18,
    r: 3,
    transform: "rotate(-180 96 18)",
    fill: "#14B6A7"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 18,
    r: 3,
    transform: "rotate(-180 81 18)",
    fill: "#14B6A7"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 18,
    r: 3,
    transform: "rotate(-180 66 18)",
    fill: "#14B6A7"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 18,
    r: 3,
    transform: "rotate(-180 51 18)",
    fill: "#14B6A7"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 18,
    r: 3,
    transform: "rotate(-180 36 18)",
    fill: "#14B6A7"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 3,
    r: 3,
    transform: "rotate(-180 111 3)",
    fill: "#14B6A7"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 3,
    r: 3,
    transform: "rotate(-180 96 3)",
    fill: "#14B6A7"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 3,
    r: 3,
    transform: "rotate(-180 81 3)",
    fill: "#14B6A7"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 3,
    r: 3,
    transform: "rotate(-180 66 3)",
    fill: "#14B6A7"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 3,
    r: 3,
    transform: "rotate(-180 51 3)",
    fill: "#14B6A7"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 3,
    r: 3,
    transform: "rotate(-180 36 3)",
    fill: "#14B6A7"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 209,
    r: 3,
    transform: "rotate(-180 282 209)",
    fill: "#14B6A7"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 209,
    r: 3,
    transform: "rotate(-180 267 209)",
    fill: "#14B6A7"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 209,
    r: 3,
    transform: "rotate(-180 252 209)",
    fill: "#14B6A7"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 209,
    r: 3,
    transform: "rotate(-180 237 209)",
    fill: "#14B6A7"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 209,
    r: 3,
    transform: "rotate(-180 222 209)",
    fill: "#14B6A7"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 209,
    r: 3,
    transform: "rotate(-180 207 209)",
    fill: "#14B6A7"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 194,
    r: 3,
    transform: "rotate(-180 282 194)",
    fill: "#14B6A7"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 194,
    r: 3,
    transform: "rotate(-180 267 194)",
    fill: "#14B6A7"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 194,
    r: 3,
    transform: "rotate(-180 252 194)",
    fill: "#14B6A7"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 194,
    r: 3,
    transform: "rotate(-180 237 194)",
    fill: "#14B6A7"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 194,
    r: 3,
    transform: "rotate(-180 222 194)",
    fill: "#14B6A7"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 194,
    r: 3,
    transform: "rotate(-180 207 194)",
    fill: "#14B6A7"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 179,
    r: 3,
    transform: "rotate(-180 282 179)",
    fill: "#14B6A7"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 179,
    r: 3,
    transform: "rotate(-180 267 179)",
    fill: "#14B6A7"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 179,
    r: 3,
    transform: "rotate(-180 252 179)",
    fill: "#14B6A7"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 179,
    r: 3,
    transform: "rotate(-180 237 179)",
    fill: "#14B6A7"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 179,
    r: 3,
    transform: "rotate(-180 222 179)",
    fill: "#14B6A7"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 179,
    r: 3,
    transform: "rotate(-180 207 179)",
    fill: "#14B6A7"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 164,
    r: 3,
    transform: "rotate(-180 282 164)",
    fill: "#14B6A7"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 164,
    r: 3,
    transform: "rotate(-180 267 164)",
    fill: "#14B6A7"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 164,
    r: 3,
    transform: "rotate(-180 252 164)",
    fill: "#14B6A7"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 164,
    r: 3,
    transform: "rotate(-180 237 164)",
    fill: "#14B6A7"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 164,
    r: 3,
    transform: "rotate(-180 222 164)",
    fill: "#14B6A7"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 164,
    r: 3,
    transform: "rotate(-180 207 164)",
    fill: "#14B6A7"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 149,
    r: 3,
    transform: "rotate(-180 282 149)",
    fill: "#14B6A7"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 149,
    r: 3,
    transform: "rotate(-180 267 149)",
    fill: "#14B6A7"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 149,
    r: 3,
    transform: "rotate(-180 252 149)",
    fill: "#14B6A7"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 149,
    r: 3,
    transform: "rotate(-180 237 149)",
    fill: "#14B6A7"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 149,
    r: 3,
    transform: "rotate(-180 222 149)",
    fill: "#14B6A7"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 149,
    r: 3,
    transform: "rotate(-180 207 149)",
    fill: "#14B6A7"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 134,
    r: 3,
    transform: "rotate(-180 282 134)",
    fill: "#14B6A7"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 134,
    r: 3,
    transform: "rotate(-180 267 134)",
    fill: "#14B6A7"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 134,
    r: 3,
    transform: "rotate(-180 252 134)",
    fill: "#14B6A7"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 134,
    r: 3,
    transform: "rotate(-180 237 134)",
    fill: "#14B6A7"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 134,
    r: 3,
    transform: "rotate(-180 222 134)",
    fill: "#14B6A7"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 134,
    r: 3,
    transform: "rotate(-180 207 134)",
    fill: "#14B6A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207 148C207 188.869 173.869 222 133 222L-150 222V74L133 74C173.869 74 207 107.131 207 148Z",
    fill: "#14B6A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGroup);
export default __webpack_public_path__ + "static/media/right-group.05a970d97525a32094c8da8fbfb87440.svg";
export { ForwardRef as ReactComponent };